import React from "react";
import Box from "@mui/material/Box";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Fonts } from "shared/constants/AppEnums";
import { CmsMasterData } from "types/models/cmsMaster/CmsMasterApp";
import { Button } from "@mui/material";
import { useNavigate } from "react-router";

interface CmsProps {
  cms: CmsMasterData;
  onBack?: () => void;
}

const CmsUpdateHeader: React.FC<CmsProps> = ({ cms, onBack }) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    if (onBack) {
      onBack();
    }
    navigate("/pages");
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexDirection: { xs: "column", sm: "row" },
        pb: 5,
        mb: 2,
        borderBottom: "1px solid #E5E4EA",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={handleBackClick}
          sx={{
            textTransform: "none",
            color: "black",
            padding: 0,
            minWidth: "auto",
          }}
        />
        <Box
          component="h3"
          sx={{
            color: "text.primary",
            fontWeight: Fonts.BOLD,
            fontSize: 16,
            ml: 0.5,
            mb: { xs: 1, sm: 0 },
          }}
        >
          {cms.PageID ? "Edit Cms" : "Add New Cms"}
        </Box>
      </Box>
    </Box>
  );
};

export default CmsUpdateHeader;
